import React from 'react'
import { PaperCard } from '../../components'
import { CircularProgress, FormLabel, Grid, TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import useEmployeeSearch from '../../components/hooks/useEmployeeSearch'
import Search from '../../components/search/search'
import { formatNumber } from 'intl-number-helper'
import EmailButton from '../../components/button/emailButton'
import { fetcherSWR } from '../../services/api/fetcher'
import useLoanInfo from '../../components/hooks/useLoanInfo'
import { format } from 'date-fns'
import { enUS } from 'date-fns/locale'
import SavingsAccountStatement from '../savingsaccountstatemens/table'

const useStyles = makeStyles((theme) => ({
    atentamente: {
        fontWeight: "bold"
    },
    centerRow: {
        textAlign: "center"
    },
    sign: {
        height: "12px"
    },
    hr: {
        border: "none",
        height: "2px",
        backgroundColor: "black"
    },
    panel: {
        marginTop: "1rem"
    },
    p: {
        [theme.breakpoints.down("sm")]: {
            fontSize: '.8em'
        }
    },
    label: {
        fontSize: "16px",
        color: theme.palette.grey[600],
    },
    value: {
        fontSize: "16px",
        color: theme.palette.grey[800],
    },
    saldoPanel : {
        marginBottom: "1rem",
        marginTop: "1rem"
    }
}))

const getFinalBalance = (accountStatus) => {
    return accountStatus ? accountStatus.length > 0 ? accountStatus[accountStatus.length - 1].Saldo : 0 : 0
}

const Index = () => {
    const classes = useStyles()
    const [employeeNum, setEmployeeNum] = React.useState("-1")
    const [entity, setEntity] = React.useState(null)
    const [saldo, setSaldo] = React.useState(0)
    const [sendEmail, setSendEmail] = React.useState(false)
    const today = new Date()
    const firstDateYear = `${today.getFullYear()}-01-01`
    const currentDate = format(today,"yyyy-MM-dd",{ locale: enUS })

    const { isLoading, data: employee, error } = useEmployeeSearch(employeeNum)
    const { isLoading: LoadingAhorro, data , error: errorAhorro } = useLoanInfo(employee ? employee.EmpresaConvenioId : 0, employee ? employee.Id : 0)

    React.useEffect(() => {
        setEntity(employee)
    }, [employee, employeeNum])

    const numEmployeeHandler = (numEmp) => {
        setEmployeeNum(numEmp)
    }

    const saldoHandler = (accountStatus) => {
        setSaldo(getFinalBalance(accountStatus))
    }

    const onClickHandler = () => {
        setSendEmail(true)
        fetcherSWR(`/api/registrarprestamosahorro/estadocuentaemail/${employee.EmpresaConvenioId}/${employee.Id}/${data.TipoProductoFinancieroId}/${firstDateYear}/${currentDate}`).then( data => {
            setSendEmail(false)
        })
    }

    if (error)
        return <p>error</p>

    if (errorAhorro)
        return <p>error</p>

    return (
        <PaperCard>
            <Grid container spacing={2}>
                <Grid item sm={12}>
                    <Search onSearchChange={numEmployeeHandler} />
                </Grid>
                {entity &&
                    <>
                        <Grid item xs={12}>
                            <TextField value={entity.Busqueda}
                                label="Nombre de Empleado"
                                fullWidth
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                        {LoadingAhorro ?
                            <CircularProgress />
                            :
                            <TextField label="Plan de Ahorro" value={data ? data.PlanAhorro: ""} fullWidth disabled />}
                        </Grid>
                    </>
                }
                {isLoading && <Grid item xs={12}><CircularProgress /> </Grid>}
                {entity && data &&
                    <Grid container justify={"flex-end"} className={classes.saldoPanel}>
                        <Grid item xs={2} sm={2} md={1} lg={1}>
                            <FormLabel className={classes.label}>Saldo</FormLabel>
                        </Grid>
                        <Grid item xs={4} sm={2} md={2} lg={1}>
                            <FormLabel className={classes.value}>{formatNumber(saldo, "en-US", "$")}</FormLabel>
                        </Grid>
                    </Grid>
                }
                <Grid container justify={"flex-end"}>
                    {entity ? data ? !sendEmail ? <EmailButton onClick={onClickHandler} /> : <CircularProgress /> : null : null}
                </Grid>
                {LoadingAhorro && <CircularProgress />}
                {!LoadingAhorro && employee &&
                    <Grid item xs={12} sm={12}>
                        {data && <SavingsAccountStatement
                            onSaldoChange={saldoHandler}
                            userid={employee.Id}
                            empresaconvenioid={employee.EmpresaConvenioId}
                            savingPlan={data}
                            currentDate={currentDate}
                            firstDateYear={firstDateYear}
                        />}
                    </Grid>
                }
            </Grid>
        </PaperCard>
    )
}

export default Index


